var _circle, _rect, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureFlagDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "#FFEBEE",
    stroke: "#F44336",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 2,
    height: 16,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8 L22 8 L22 14 L18 16 L22 18 L22 24 L12 24 Z",
    fill: "#BDBDBD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 3,
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.5 L23.5 11.5 M23.5 8.5 L20.5 11.5",
    stroke: "white",
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFlagDisabled);
export default __webpack_public_path__ + "static/media/feature-flag-disabled.20206c63e8cc7c702fb9c7296eb493a2.svg";
export { ForwardRef as ReactComponent };